import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { ApplicationVAT } from "../../../models/finance/application-vat";
import VatService from "../../../services/finance/vat-service";
import { RootState } from "../../store";
import { ApplicationError } from "../../../models/errors/application-error";


export const fetchVat = createAsyncThunk<
    ApplicationVAT[] | null,
    void,
    { state: RootState }
>("finance/getVat", async (_, { rejectWithValue }) => {
    const vatService = new VatService();
    try {
        return await vatService.getVatList();
    } catch (error: any) {
        const apiError = ApplicationError.handleApiError(error, {});
        return rejectWithValue(apiError);
    }
});


interface VatState {
    vat: ApplicationVAT[]
}


const initialState: VatState = {
    vat: []
}

export const vatSlice = createSlice({
    name: 'vat',
    initialState,
    reducers: {

    },
    extraReducers(builder) {
        builder.addCase(
            fetchVat.fulfilled,
            (state, action: PayloadAction<ApplicationVAT[] | null>) => {
                if (action.payload) {
                    state.vat = action.payload;
                }
            }
        );
    },
})

export default vatSlice.reducer